module.exports = __webpack_public_path__ + "assets/img/info_error.c403b0f5.svg";